export enum ETravelTypes {
  Liste = 'Liste',
  ListeZeit = 'ListeZeit',
  DatumZeit = 'DatumZeit',
  Datum = 'Datum',
  Woche = 'Woche',
  Monat = 'Monat',
  Jahr = 'Jahr',
}
